
export default {
    mounted () {
        const WOW = require('wow.js')
        new WOW().init()
    },
}
